import { useEffect, useRef, useState } from 'react';
import axiosInstance from '../api/axiosInstance';

const POLL_INTERVAL = 60 * 1000;
const VERSION_URL = '/version.json';
const STORAGE_KEY = 'app_version';
const EVENT_REFRESH = 'app:refresh';
const COUNTDOWN_SECONDS = 5;

function isTypingField(el) {
    if (!el) return false;
    const tag = el.tagName;
    return tag === 'INPUT' || tag === 'TEXTAREA' || el.isContentEditable;
}

async function fetchVersion() {
    try {
        const res = await fetch(`${VERSION_URL}?_=${Date.now()}`, { cache: 'no-store' });
        if (!res.ok) return null;
        const { version } = await res.json();
        return version || null;
    } catch {
        return null;
    }
}

async function keepAlive() {
    try {
        await axiosInstance.get('/User/ping', { timeout: 5000 });
    } catch {
        // ignore — 401 handling already done by interceptor
    }
}

function broadcastRefresh() {
    window.dispatchEvent(new CustomEvent(EVENT_REFRESH));
}

export default function useAppPolling() {
    const startedRef = useRef(false);
    const [updateAvailable, setUpdateAvailable] = useState(false);

    useEffect(() => {
        if (startedRef.current) return;
        startedRef.current = true;

        const checkVersion = async () => {
            const version = await fetchVersion();
            if (!version) return;
            const stored = localStorage.getItem(STORAGE_KEY);
            if (!stored) {
                localStorage.setItem(STORAGE_KEY, version);
                return;
            }
            if (stored !== version) {
                localStorage.setItem(STORAGE_KEY, version);
                setUpdateAvailable(true);
            }
        };

        const tick = () => {
            checkVersion();
            keepAlive();
            broadcastRefresh();
        };
        tick();
        const id = setInterval(tick, POLL_INTERVAL);
        return () => clearInterval(id);
    }, []);

    return { updateAvailable, countdownSeconds: COUNTDOWN_SECONDS, isTypingField };
}

export { EVENT_REFRESH };
